import React from "react";
import { Button, dialog, Progress } from "../../nq-component";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  countObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import withRouter from "../../withRouter";
import NavBar from "../../components/navbar";
import AuditLogsListPagePresenter from "./AuditLogsListPagePresenter";
import BaseListPage from "../../base/BaseListPage";
import { exportCSVUseCase } from "../../usecases/csv/usecases";
import {
  addSchemaUseCase,
  deleteSchemaUseCase,
  updateSchemaUseCase,
} from "../../usecases/schema/usecases";
import PageTitle from "./components/PageTitle";
import AuditList from "./components/AuditList";

class AuditLogsListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AuditLogsListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      objects: [],
    };
  }

  getCollectionName() {
    return "audit_logs";
  }

  goBack() {
    window.history.back();
  }

  getApplicationId() {
    return this.props.params.id;
  }

  render() {
    const { objects, progress } = this.state;
    const user = this.getCurrentUser();

    console.warn("objects", objects);
    return (
      <>
        <NavBar user={user} />
        {progress ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <Progress />
          </div>
        ) : (
          <div>
            <div className="p-4 overflow-auto">
              <PageTitle onBack={this.goBack.bind(this)} />
              <div className="d-flex flex-column">
                <AuditList AuditObjects={objects} />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(AuditLogsListPage);
